import axios from 'axios'
import { createPrefix } from 'utils/create-prefix'

export class BeneficiaryService {
  constructor() {
    this.endpoints = {
      ...createPrefix('/beneficiary/transaction', {
        transHistory: '/history',
      }),
      ...createPrefix('/self-register', {
        createBeneficiarySelfReg: '/',
      }),
    }
  }

  static create() {
    return new BeneficiaryService()
  }

  async getBeneficiaryTransHistory(params) {
    const servicePath = this.endpoints.transHistory()
    const { data } = await axios.get(servicePath, { params })
    return data
  }
}
